import type { ListPluginsResponse, MySubmissionsResponse, PluginSurface } from "@scoach/types";

import { api } from "../../lib/http.ts";

export const pluginsApi = {
  /** Approved plugins the caller can render (optionally by surface), with enabled state. */
  list: (surface?: PluginSurface) =>
    api<ListPluginsResponse>("/api/marketplace/plugins", {
      query: surface ? { surface } : undefined,
    }),

  /** Toggle per-user enablement (opt-in) of an approved plugin. */
  setEnabled: (id: string, enabled: boolean) =>
    api<{ ok: boolean }>(`/api/marketplace/plugins/${id}/enable`, {
      method: "POST",
      body: { enabled },
    }),

  /** The developer's own submissions + review states (Developer hub). */
  mine: () => api<MySubmissionsResponse>("/api/marketplace/plugins/mine"),

  /** Re-run the security scan after fixing findings. */
  resubmit: (id: string) =>
    api<{ ok: boolean; reviewState: string }>(`/api/marketplace/plugins/${id}/resubmit`, {
      method: "POST",
    }),

  /** Promote the developer's own PRIVATE plugin to everyone (enters admin review). */
  publish: (id: string) =>
    api<{ ok: boolean; reviewState: string }>(`/api/marketplace/plugins/${id}/publish`, {
      method: "POST",
    }),

  /** Submit a new plugin (multipart form-data; optional image). */
  suggest: (fd: FormData) =>
    api<{ ok: boolean; id: string; reviewState: string }>("/api/marketplace/plugins/suggest", {
      method: "POST",
      body: fd,
    }),
};
